<template>
  <v-container fluid>
    <v-layout column>
      <v-flex xs12 mb-5>
        <div class="mb-4">
          <h2 class="display-1 pb-1">Отдел оптовых продаж</h2>
          <div class="font-weight-light ml-3">понедельник - пятница 10:00 - 18:00</div>
          <div class="font-weight-light ml-3">суббота 10:00 - 15:00</div>
        </div>
        <v-container fluid grid-list-sm pa-0>
          <v-layout row wrap justify-center>
            <v-flex class="manager-card" v-for="manager in managers" :key="manager.name">
              <v-card>
                <v-card-title>
                  <div class="subheading">{{ manager.name }}</div>
                </v-card-title>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon color="accent">mdi-phone</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title><a :href="`tel:${manager.phone}`">{{ manager.phone }}</a></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>

                  <v-divider inset></v-divider>

                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon color="accent">mdi-telegram</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title><a :href="`tg://resolve?domain=${manager.telegram}`">{{ manager.telegram }}</a>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
      <v-flex xs12>
        <div class="mb-4">
          <h2 class="display-1 pb-1">Сервисный центр</h2>
          <div class="font-weight-light ml-3">понедельник - пятница 10:00 - 18:00</div>
          <div class="font-weight-light ml-3">Минск, ул. Скрыганова 6а, этаж 1, офис 10</div>
        </div>
        <v-card>
          <v-container fluid pa-0>
            <v-layout row wrap justify-center>
              <v-flex lg3 md4 sm5 xs12>
                <v-card class="elevation-0">
                  <v-card-title>
                    <div>
                      <div class="subheading">Денис</div>
                      <span class="grey--text">Начальник гарантии</span>
                    </div>
                  </v-card-title>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="accent">mdi-phone</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title><a :href="`tel:+375 (33) 343-98-01`">+375 (33) 343-98-01</a>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>

                    <v-divider inset></v-divider>

                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="accent">mdi-email</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title><a href="mailto:d.nikitash@n-tech.by">d.nikitash@n-tech.by</a>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset></v-divider>

                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="accent">mdi-telegram</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title><a href="tg://resolve?domain=RMA_NT">RMA_NT</a></v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card>
                <v-divider></v-divider>
                <v-card class="elevation-0">
                  <v-card-title>
                    <div>
                      <div class="subheading">Сергей</div>
                      <span class="grey--text">Приемка и выдача товара, возвраты</span>
                    </div>
                  </v-card-title>
                  <v-list>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="accent">mdi-phone</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title><a :href="`tel:+375 (29) 651-22-56`">+375 (29) 651-22-56</a>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset></v-divider>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="accent">mdi-phone</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title><a :href="`tel:+375 (29) 851-22-56`">+375 (29) 851-22-56</a>
                        </v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                    <v-divider inset></v-divider>
                    <v-list-tile>
                      <v-list-tile-action>
                        <v-icon color="accent">mdi-telegram</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-content>
                        <v-list-tile-title><a href="tg://resolve?domain=Priemka_NT">Priemka_NT</a></v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-flex>
              <v-flex lg9 md8 sm7 xs12>
                <v-card class="elevation-0">
                  <yandex-map
                      :coords="[53.910585,27.517059]"
                      zoom="16"
                      class="contacts-map"
                      :placemarks="placemarks"
                      map-type="map"
                  >

                    <ymap-marker
                        marker-id="1"
                        marker-type="placemark"
                        :coords="[53.910585,27.517059]"
                        :balloon="{header: 'Сервисный центр', body: 'Минск, ул. Скрыганова 6а, этаж 1, офис 10<br>понедельник - пятница 10:00 - 18:00'}"
                        :icon="{glyph: 'leisure'}"
                        cluster-name="1"
                    ></ymap-marker>
                  </yandex-map>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import { yandexMap, ymapMarker } from 'vue-yandex-maps'

export default {
  name: 'Contacts',
  components: { yandexMap, ymapMarker },
  data () {
    return {
      placemarks: [
        {
          coords: [54.8, 39.8],
          properties: {}, // define properties here
          options: {}, // define options here
          clusterName: '1',
          balloonTemplate: '<div>"Your custom template"</div>',
          callbacks: { click: function () {} }
        }
      ],
      managers: [
        {
          name: 'Марина',
          phone: '+375 (25) 623-14-72',
          operator: 'Лайф',
          telegram: 'Sunshine_fine'
        },
        {
          name: 'Валерий',
          phone: '+375 (29) 501-08-05',
          operator: 'Велком',
          telegram: 'Gar113'
        },
        {
          name: 'Евгений',
          phone: '+375 (29) 318-09-56',
          operator: 'Велком',
          telegram: 'MaloyZeka'
        },
        {
          name: 'Александр',
          phone: '+375 (29) 633-29-18',
          operator: 'Велком',
          telegram: 'Sanjasajt'
        }
      ]
    }
  }
}
</script>

<style lang="stylus">
.manager-card {
  max-width: 400px;
  @media screen and (max-width: 599px) {
    max-width: 100%;
  }
}

.contacts-map {
  width: 100%
  height: 500px;
  @media screen and (max-width: 599px) {
    height: 200px;
  }
  @media screen and (min-width: 600) and (max-width: 1263px) {
    height: 300px;
  }

}
</style>
